const n = () => {
  const e = document.cookie.match(RegExp("(?:^|;\\s*)consented_policy_version=([^;]*)"));
  return e ? Number(e[1]) : void 0;
};
export {
  n as default
};
